var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95563 9.42479C2.0608 9.40772 2.16723 9.39985 2.27372 9.40123H20.4063L20.0109 9.21733C19.6245 9.0344 19.2729 8.78545 18.9719 8.48173L13.8871 3.39689C13.2174 2.7576 13.1049 1.7292 13.6204 0.96021C14.2204 0.140763 15.3711 -0.0371606 16.1906 0.562871C16.2569 0.611375 16.3198 0.664246 16.3789 0.72114L25.5739 9.91615C26.2925 10.6339 26.2931 11.7983 25.5754 12.5169C25.5749 12.5174 25.5744 12.5179 25.5739 12.5183L16.3789 21.7133C15.6598 22.4305 14.4954 22.4289 13.7782 21.7097C13.7217 21.6531 13.669 21.5929 13.6204 21.5294C13.1049 20.7605 13.2174 19.732 13.8871 19.0928L18.9627 13.9987C19.2325 13.7286 19.5427 13.5021 19.8822 13.3275L20.4339 13.0792H2.37492C1.43548 13.1141 0.611261 12.4579 0.434774 11.5345C0.272196 10.5319 0.953087 9.58743 1.95563 9.42479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow02);
export default __webpack_public_path__ + "static/media/right_arrow02.46bb7e7c764c941e13d5c6e0667ad85f.svg";
export { ForwardRef as ReactComponent };